<template>
  <router-link
    v-if="isLoggedIn"
    :to="{ name: homeRoute }"
    data-test="nexcess-logo-home"
    class="logo-container"
  >
    <div class="logo-inner">
      <img :src="logoSrc" :alt="formatters.text.capitalize(company.name)" />
    </div>
  </router-link>
  <a v-else :href="SPIDEY_URL" class="logo-container">
    <div class="logo-inner">
      <img :src="logoSrc" :alt="formatters.text.capitalize(company.name)" />
    </div>
  </a>
</template>

<script>
import { computed } from "vue";
import { constants } from "@/utils";
import { formatters } from "leatherman-js";
import store from "@/store";

export default {
  name: "NavLogo",
  setup() {
    const company = computed(() => store.getters["company/get"]);
    const homeRoute = constants.ROUTES.HOME;
    const isLoggedIn = computed(() => store.getters["auth/isLoggedIn"]);
    const SPIDEY_URL = process.env.VUE_APP_SPIDEY_URL;
    const theme = computed(() => store.getters["theme/get"]);
    const logoSrc = computed(() => {
      return {
        default: require("@/assets/nexcess-text-black.svg"),
        dark: require("@/assets/nexcess-text-white.svg"),
      }[theme.value.stylesheet];
    });

    return {
      company,
      formatters,
      homeRoute,
      isLoggedIn,
      SPIDEY_URL,
      logoSrc,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.logo-container {
  margin: 16px 16px 0 16px;
  flex-grow: 0;
  display: block;

  .logo-inner {
    max-height: 58px;
    max-width: 182px;
    height: 100%;

    img {
      height: 100%;
    }
  }
}
</style>
